import { api } from "./client";

export const authService = {
  // Check if user is authenticated via backend-managed HttpOnly cookie
  me: async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.get("auth/me");
    const data = response.responseBody.data;

    // Map backend response to User interface
    return {
      id: data.employeeId || data.cognitoId,
      firstName: data.firstName,
      lastName: data.lastName,
      name: data.email?.split("@")[0] || "User", // Fallback name if missing
      email: data.email,
      authProvider: data.authProvider || "email",
      roles: data.role ? [data.role.toLowerCase()] : [], // Map single role to array and lowercase
      managerId: data.managerId,
      gender: data.gender,
      country: data.country,
      contactNumber: data.contactNumber,
      address: data.address,
      dob: data.dob,
      emergencyContact: data.emergencyContact,
      isProfileCompleted: data.isProfileCompleted,
    };
  },

  // Custom login with email and password
  login: async (email: string, password: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("auth/login", { email, password });
    return response.responseBody.data;
  },

  // Forgot password - initiate password reset
  forgotPassword: async (email: string) => {
    return api.post("auth/forgot-password", { email });
  },

  // Reset password with OTP
  resetPassword: async (email: string, code: string, newPassword: string) => {
    return api.post("auth/reset-password", { email, code, newPassword });
  },

  // Change password (for first-time login or voluntary change)
  changePassword: async (data: {
    email: string;
    oldPassword: string;
    newPassword: string;
  }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("auth/change-password", data);
    return response.responseBody.data;
  },

  // Set local password for users who initially signed in via OAuth
  setLocalPassword: async (newPassword: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("auth/set-local-password", {
      newPassword,
    });
    return response.responseBody.data;
  },

  // Exchange authorization code for session (backend sets HttpOnly cookie)
  callback: async (code: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("auth/callback", { code });
    return response.responseBody.data;
  },

  // Logout - backend clears HttpOnly cookie
  logout: async () => {
    return api.post("auth/logout", {});
  },
};
